module.exports = __webpack_public_path__ + "img/Radxa64_48.a17dd810.png";